import { CaretDown, CaretDownFill, CaretUp, CaretUpFill } from "react-bootstrap-icons"

export type Orden = {
	columna: number,
	ascendente: boolean
}
export const ControlesOrden: React.FC<{ columna: number, orden: Orden, handler: Function }> = ({ columna, orden, handler }) => {
	return <span>
		<span className="d-inline-flex flex-column">
			{(columna === orden.columna && orden.ascendente) && <CaretUpFill style={{ cursor: 'pointer' }} onClick={()=>handler({columna:columna,ascendente:true})} />}
			{(columna !== orden.columna || !orden.ascendente) && <CaretUp style={{ cursor: 'pointer' }} onClick={()=>handler({columna:columna,ascendente:true})} />}
			{(columna === orden.columna && !orden.ascendente) && <CaretDownFill style={{ cursor: 'pointer' }} onClick={()=>handler({columna:columna,ascendente:false})} />}
			{(columna !== orden.columna || orden.ascendente) && <CaretDown style={{ cursor: 'pointer' }} onClick={()=>handler({columna:columna,ascendente:false})} />}
		</span>
	</span>
}